import React from "react";
import Logo from "./img/logo.png";
import "./header.css";
const mystyle = {
  color: "white",
  padding: "10px",
  fontFamily: "Arial",
};
export const Header = () => {
  return (
    <div class="header" style={mystyle}>
      <img src={Logo} />
    </div>
  );
};
